<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="voltarParaListagem">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Lançar Frequência
        </h1>
      </v-col>
    </v-row>

    <v-row v-if="atendimento">
      <v-col cols="12">
        <v-card color="green lighten-1" outlined>
          <v-card-text>
            <h4>Aluno: {{ matricula && matricula.aluno ? matricula.aluno.nomecompleto : "" }}</h4>
            <h4>Turma: {{ matricula && matricula.turma ? matricula.turma.descricao : "" }}</h4>
            <h4>Data: {{ atendimento.data_formatada }}</h4>
            <h4>Horário: {{ atendimento.horario ? atendimento.horario.descricao : "- - -" }}</h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <form @submit.prevent="salvarFrequencia">
      <v-row>
        <v-col cols="12">
          <e-label>O aluno esteve presente neste atendimento?</e-label>
          <v-radio-group v-model="form.presenca" row>
            <v-radio label="Presente" :value="true"></v-radio>
            <v-radio label="Ausente" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12">
          <e-label>Observação</e-label>
          <v-textarea
            rows="3"
            solo
            dense
            v-model="form.observacao_frequencia"
            placeholder="Registre aqui a justificativa da ausência ou qualquer observação relevante"
          />
        </v-col>
        <v-col cols="12">
          <v-btn
            color="primary"
            :disabled="enviando || form.presenca === null"
            :loading="enviando"
            type="submit"
            >Salvar Frequência</v-btn
          >
        </v-col>
      </v-row>
    </form>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      enviando: false,
      matricula: null,
      atendimento: null,
      form: {
        presenca: null,
        observacao_frequencia: null,
      },
    };
  },
  computed: {
    matriculaId() {
      return parseInt(this.$route.params.matricula_id, 10);
    },
    atendimentoId() {
      return parseInt(this.$route.params.atendimento_id, 10);
    },
  },
  async mounted() {
    await this.carregarAtendimento();
  },
  methods: {
    async carregarAtendimento() {
      this.$loaderService.open("Carregando atendimento...");
      try {
        const response = await this.$services.educacaoInclusivaService.listar(this.matriculaId);
        this.matricula = response.matricula;
        this.atendimento = response.lancamentos.find((l) => l.id === this.atendimentoId);

        if (!this.atendimento) {
          this.$toast.danger("Atendimento não encontrado.");
          this.voltarParaListagem();
          return;
        }

        this.form.presenca = this.atendimento.presenca;
        this.form.observacao_frequencia = this.atendimento.observacao_frequencia;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async salvarFrequencia() {
      this.enviando = true;
      try {
        await this.$services.educacaoInclusivaService.lancarFrequencia(
          this.atendimentoId,
          this.form
        );
        this.$toast.success("Frequência lançada com sucesso!");
        this.voltarParaListagem();
      } catch (error) {
        this.$handleError(error);
      }
      this.enviando = false;
    },
    voltarParaListagem() {
      this.$router.push({
        name: "educacaoInclusiva.atendimentos",
        params: { matricula_id: this.matriculaId },
      });
    },
  },
};
</script>
